import { DepartmentCode } from '../models/Department';

let activeDepartmentCode: DepartmentCode | undefined;

export const setActiveDepartmentCode = (departmentCode?: DepartmentCode) => {
	activeDepartmentCode = departmentCode;
};

export const getActiveDepartmentCode = () => activeDepartmentCode;

export const getCurrentHostName = () =>
	typeof window === 'undefined' ? '' : window.location.host;
